<br />
<!--<img src="../../../assets/pageImg/iconfinder_system-lock-screen_118795.png" style="width:150px" />-->
<img src="../../../assets/backgroundImgs/401-Page-02.png" style="width:400px" />
<br />
<br />
<span style="font-weight:bold;font-size:30px">
  抱歉，您沒有足夠的權限進入!!
</span>
<br />
<br />
<button style="opacity:0.7" mat-raised-button color="primary" routerLink="/home">返回首頁</button>
